// Mobile 端特效横向拼接，PC 端特效竖向拼接
var getVsSource = function getVsSource(isMobileView) {
  return "\n  attribute vec4 aPosition;\n  attribute vec4 aTextureCoord;\n  varying highp vec2 vTextureCoord;\n  varying highp vec2 vTextureCoord2;\n\n  void main() {\n    gl_Position = aPosition;\n    ".concat(isMobileView ? "\n      vTextureCoord = vec2(aTextureCoord.x*0.5+0.5, aTextureCoord.y);\n      vTextureCoord2 = vec2(aTextureCoord.x*0.5, aTextureCoord.y);\n    " : "\n      vTextureCoord = vec2(aTextureCoord.x, aTextureCoord.y*0.5);\n      vTextureCoord2 = vec2(aTextureCoord.x, aTextureCoord.y*0.5+0.5);\n    ", "\n  }\n");
};

var getFsSource = function getFsSource() {
  return "\n  precision mediump float;\n  varying highp vec2 vTextureCoord;\n  varying highp vec2 vTextureCoord2;\n  uniform lowp sampler2D sTexture;\n\n  void main() {\n    vec4 color1 = texture2D(sTexture, vTextureCoord);\n    vec4 color2 = texture2D(sTexture, vTextureCoord2);\n    gl_FragColor = vec4(color1.rgb, color2.r);\n  }\n";
}; // creates a shader of the given type, uploads the source and compiles it.


function loadShader(gl, type, source) {
  var shader = gl.createShader(type); // Send the source to the shader object

  gl.shaderSource(shader, source); // Compile the shader program

  gl.compileShader(shader); // See if it compiled successfully

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    /* eslint-disable-next-line no-alert */
    alert("An error occurred compiling the shaders: ".concat(gl.getShaderInfoLog(shader)));
    gl.deleteShader(shader);
    return null;
  }

  return shader;
} // Initialize a shader program, so WebGL knows how to draw our data

function initShaderProgram(gl, isMobileView) {
  var vertexShader = loadShader(gl, gl.VERTEX_SHADER, getVsSource(isMobileView));
  var fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, getFsSource()); // Create the shader program

  var shaderProgram = gl.createProgram();
  gl.attachShader(shaderProgram, vertexShader);
  gl.attachShader(shaderProgram, fragmentShader);
  gl.linkProgram(shaderProgram);

  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
    /* eslint-disable-next-line no-console */
    console.log("Unable to initialize the shader program: ".concat(gl.getProgramInfoLog(shaderProgram)));
    return {};
  }

  return {
    shaderProgram: shaderProgram,
    vertexShader: vertexShader,
    fragmentShader: fragmentShader
  };
} // initBuffers

function initBuffers(gl) {
  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  var VERTICES_DATA = [// X, Y, Z, U, V
  -1.0, -1.0, 0.0, 0.0, 1.0, 1.0, -1.0, 0.0, 1.0, 1.0, -1.0, 1.0, 0.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0, 0.0];
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(VERTICES_DATA), gl.STATIC_DRAW);
  return {
    vertices: buf
  };
} // Initialize a texture.

function initTexture(gl) {
  var texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture); // Because video havs to be download over the internet
  // they might take a moment until it's ready so
  // put a single pixel in the texture so we can
  // use it immediately.

  var level = 0;
  var internalFormat = gl.RGBA;
  var width = 1;
  var height = 1;
  var border = 0;
  var srcFormat = gl.RGBA;
  var srcType = gl.UNSIGNED_BYTE;
  var pixel = new Uint8Array([0, 0, 0, 0]); // transparent

  gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel); // Turn off mips and set wrapping to clamp to edge so it
  // will work regardless of the dimensions of the video.

  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  return texture;
} // copy the video texture

function updateTexture(gl, texture, video) {
  var level = 0;
  var internalFormat = gl.RGBA;
  var srcFormat = gl.RGBA;
  var srcType = gl.UNSIGNED_BYTE;
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, video);
} // Draw the scene.

function drawScene(gl, programInfo, buffers, texture) {
  gl.clearColor(0.0, 0.0, 0.0, 1.0); // Clear to black, fully opaque
  // Clear the canvas before we start drawing on it.

  gl.clear(gl.COLOR_BUFFER_BIT); // Tell WebGL to use our program when drawing

  gl.useProgram(programInfo.program);
  gl.bindBuffer(gl.ARRAY_BUFFER, buffers.vertices); // Tell WebGL how to pull out the positions from the vertices
  // buffer into the position attribute

  {
    var numComponents = 3;
    var type = gl.FLOAT;
    var normalize = false;
    /* eslint-disable-next-line no-magic-numbers */

    var stride = (3 + 2) * 4;
    var offset = 0;
    gl.vertexAttribPointer(programInfo.attribLocations.position, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.position);
  } // Tell WebGL how to pull out the texture coordinates from
  // the vertices buffer into the textureCoord attribute.

  {
    var _numComponents = 2;
    var _type = gl.FLOAT;
    var _normalize = false;
    /* eslint-disable-next-line no-magic-numbers */

    var _stride = (3 + 2) * 4;
    /* eslint-disable-next-line no-magic-numbers */


    var _offset = 3 * 4;

    gl.vertexAttribPointer(programInfo.attribLocations.textureCoord, _numComponents, _type, _normalize, _stride, _offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord);
  } // Specify the texture to map onto the faces.
  // Tell WebGL we want to affect texture unit 0

  gl.activeTexture(gl.TEXTURE0); // Bind the texture to texture unit 0

  gl.bindTexture(gl.TEXTURE_2D, texture); // Tell the shader we bound the texture to texture unit 0

  gl.uniform1i(programInfo.uniformLocations.sTexture, 0);
  /* eslint-disable-next-line no-magic-numbers */

  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
}
function cleanGL(gl, program, vertexShader, fragmentShader) {
  gl.deleteProgram(program);
  gl.deleteShader(vertexShader);
  gl.deleteShader(fragmentShader);
}

export { cleanGL, drawScene, initBuffers, initShaderProgram, initTexture, loadShader, updateTexture };
